import React, { useEffect, useState } from 'react';
import { getDoc } from "firebase/firestore";
import { useParams } from 'react-router-dom';
import StoreNav from './StoreNav';
import { gsap } from 'gsap';
import { Container } from 'react-bootstrap';
import "./FullProject.scss"
import 'bootstrap/dist/css/bootstrap.min.css';
import firebase from 'firebase/compat/app';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import "./ProductPage.scss"
import { auth } from '../Firebase/Firebase';
import { onAuthStateChanged } from 'firebase/auth'
import PayWithPaystack from '../hooks/PayWithPaystack.js';
import MeteFooter from './MeteFooter';





function ProductPage() {

    useEffect(() => {
        let ctx = gsap.context(() => {
            gsap.to(".App", { duration: .0, css: { visibility: 'visible' } })
        });
        return () => {
            ctx.revert();
        };
    }, []);

    const [loading, setLoading] = useState(true);

    const [loadingText, setLoadingText] = useState('Beep Bop Boop'); // Initial loading text
    const [dotCount, setDotCount] = useState(0); // Count of dots to display
    const { id } = useParams();

    const [product, setProduct] = useState(null);
    const [error, setError] = useState(null);

    const [hasPaid, setHasPaid] = useState(false);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setUser(user); // Set the authenticated user
        });
        return () => unsubscribe(); // Cleanup the listener on unmount
    }, []);

    useEffect(() => {
        if (hasPaid && product) {
            const expiresAt = Date.now() + 2 * 60 * 60 * 1000; // 2 hours
            localStorage.setItem(
                `paidAsset_${product.id}`,
                JSON.stringify({ paid: true, expiresAt })
            );
        }
    }, [hasPaid, product]);




    useEffect(() => {
        // Simulate loading process
        const loadingTimer = setInterval(() => {
            setDotCount(prev => (prev + 1) % 4); // Cycle through 0 to 3
        }, 200); // Update every second

        // Cleanup function to clear the interval
        return () => clearInterval(loadingTimer);
    }, []);
    // Update loading text based on dotCount
    useEffect(() => {
        if (loading) {
            setLoadingText('Beep Bop Boop' + '.'.repeat(dotCount)); // Add dots based on dotCount
        }
    }, [dotCount, loading]);

    // Simulate loading completion after 5 seconds for demonstration
    useEffect(() => {
        const loadingCompleteTimer = setTimeout(() => {
            setLoading(false); // Set loading to false after 5 seconds
        }, 5000); // Change this duration as needed

        return () => clearTimeout(loadingCompleteTimer);
    }, []);

    useEffect(() => {
        // 
        const fetchProduct = async () => {
            console.log("Product ID inside fetch:", id);
            if (!id) return;
            try {
                const docRef = firebase.firestore().collection("Assets").doc(id);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    setProduct(docSnap.data());
                } else {
                    setError("No product found with this ID.");
                }
            } catch (err) {
                console.error("Error fetching product:", err);
                setError("Failed to fetch product.");
            } finally {
                setLoading(false);
            }
        };


        fetchProduct();
    }, [id]);

    // Convert bytes to a readable format
    const formatFileSize = (bytes) => {
        if (bytes === null) return 'N/A';
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
    };

    const handleDownload = (url) => {
        const a = document.createElement('a');
        a.href = url;
        a.download = ''; // Optional filename
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };


    if (error) return <div style={{ color: 'red' }}>{error}</div>;
    if (loading) return <div className='center'><p className='center-text'>{loadingText}</p></div>;
    if (!product) return <div className='center'><p className='center-text'>{loadingText}</p></div>;

    return (
        <div className="ProductPage">
            <Container className="Project">
                <StoreNav />
                <div className="cutscene">

                </div>

                <div className="folded">
                    <Row className="mainContent">
                        <Col lg={8}>

                            <div className="OnlyImage">
                                <img src={product.thumbnail} alt={product.name} className="ImageHere" />
                            </div>

                        </Col>
                        <Col lg={4} className="details">
                            <h3>{product?.name}</h3>
                            <p>{product?.fileType} </p>
                            <p><strong>{product?.category}</strong></p>
                            <p>Price: <strong>{product?.price === "free" ? "Free" : `₦${new Intl.NumberFormat("en-NG").format(product?.price)}`}</strong></p>
                            {product?.fileSize && (
                                <p>File Size: <strong>{formatFileSize(product.fileSize)}</strong></p>  // Use a helper function to format the size
                            )}
                            {product?.price !== "free" && (
                                <>
                                    <p>Click the button below to proceed with the payment.</p>
                                    <a
                                        href={product?.licenseLink}
                                        rel="noreferrer"
                                        target="_blank"
                                        className="license"
                                    >
                                        {product?.licenseText}
                                    </a>
                                    <br />
                                    <br />
                                </>
                            )}
                            {product?.price === "free" || hasPaid ? (
                                <Button variant="primary" className='learnBtn' onClick={() => handleDownload(product.id)}>
                                    Download Asset
                                </Button>
                            ) : (
                                <PayWithPaystack
                                    user={user}
                                    selectedAsset={product}
                                    setHasPaid={setHasPaid}

                                />
                            )}

                        </Col>
                    </Row>
                    <Row>
                        <p style={{ textAlign: "center" }}>Please dont purchse from this page. This Page is still under construction. Just click the purchase/download button on each card on the previous page, thank you</p>
                    </Row>
                </div>

                <MeteFooter />

            </Container>
        </div>

    )
}

export default ProductPage;
